module.exports = __webpack_public_path__ + "img/illustrations6.ed873f5b.jpg";